import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  data() {
    return {
      brandList: [],
      // 下拉品牌类型列表
      brandTypeOptionsList: [],
      // 分页配置项
      setBrandPage: {
        pageSize: 20, // 每页显示条数
        currentPage: 1, // 当前页
        total: 0, // 总条数
        totalPage: 1
      }
    }
  },
  created() {
  },
  methods: {
    initBrandList() {
      const data = {
        pageNo: this.setBrandPage.currentPage,
        pageSize: this.setBrandPage.pageSize
      }
      SmartVehicleInspection.getBrandList(data).then(res => {
        if (res.success) {
          const { records, total, size, pages } = res.result
          this.setBrandPage.pageSize = size;
          this.setBrandPage.total = total;
          this.setBrandPage.totalPage = pages;
          let arr = [];
          records.map((value, index) => {
            let obj = {};
            obj.sort = index + 1;
            obj.id = value.id;
            obj.name = value.name;
            obj.status = value.status;
            arr.push(obj);
          });
          this.brandList = arr;
          this.brandTypeOptionsList = this.brandTypeOptionsList.concat(arr)
        }
      })
    },

    // 给自定义指令用的方法
    handleScrollDropdown() {
      this.setBrandPage.currentPage++
      // 这一步是做了一个容错判断 currentPage>totalPage 时 return出去
      if (this.setBrandPage.currentPage > this.setBrandPage.totalPage) return
      // 获取列表接口
      this.initBrandList()
    }
  }
}